var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alliance-news-view"},[_c('NavBar'),_c('AllianceNews')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }